import React from 'react';
import Sidebar from './Sidebar';
import { FileText } from 'lucide-react';
import { Navigate, useNavigate } from 'react-router-dom';
import { adminAPI } from '../services/api';

const Layout = ({ user, onLogout, children }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // Call the logout API to clear authentication data
      await adminAPI.logoutAdmin();
      
      // Call the parent onLogout callback if it exists
      if (onLogout) {
        onLogout();
      }
      
      // Navigate to login page
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      
      // Even if logout API fails, clear local data and navigate
      localStorage.removeItem('authToken');
      localStorage.removeItem('adminUser');
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem('adminUser');
      
      if (onLogout) {
        onLogout();
      }
      
      navigate('/login');
    }
  };

  return (
    <div className="flex h-screen bg-background">
      <Sidebar user={user} />
      <main className="flex-1 flex flex-col overflow-hidden ml-64">
        <div className="bg-white border-b border-border px-6 shadow-sm">
          <div className="flex justify-end items-center h-16">
            <div className="flex items-center gap-4">
              <a
                href="/user-guide.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 text-sm font-medium text-primary hover:text-primary/80 transition-colors"
                title="User Guide"
              >
                <FileText className="w-4 h-4" />
                User Guide
              </a>
              <span className="text-foreground font-medium">Welcome, {user?.username || user?.full_name}</span>
              <button 
                onClick={handleLogout} 
                className="bg-destructive hover:bg-destructive/90 text-destructive-foreground px-4 py-2 rounded-md text-sm font-medium transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
        
        <div className="flex-1 p-6 overflow-y-auto">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;